import React, { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";

import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const searchStyles = makeStyles((theme) => ({
  searchField: {
    width: "50ch",
    marginTop: theme.spacing(1),
  },
}));

const SearchField = (props) => {
  const classes = searchStyles();
  const debounce = 250;

  const [value, setValue] = useState("");
  const [debounceTimer, setDebounceTimer] = useState(null);

  useEffect(() => {
    setValue(props.value[0]);
  }, []);

  const updateValue = (event) => {
    const textValue = event ? event.target.value : "";
    setValue(textValue);

    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    setDebounceTimer(
      setTimeout(() => {
        if (textValue.length > 0) {
          props.onChange(textValue.toLowerCase().split(" "));
        } else {
          props.onChange([]);
        }
        setDebounceTimer(null);
      }, debounce)
    );
  };

  return (
    <FormControl className={classes.searchField}>
      <TextField
        onChange={updateValue}
        variant="standard"
        size="small"
        value={value}
        label="Search"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end" onClick={() => updateValue()}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        datacy={"loadSavedReportsSearch"}
      />
    </FormControl>
  );
};

export default SearchField;
